/* eslint-disable no-case-declarations */
import { pascalCase } from 'pascal-case'
import { api as $axios } from '@/helpers/interceptors'
import * as path from '@/constants/path'
import { makeId, deepCopy } from '@/utils/utils'
import snakeCaseKeys from 'snakecase-keys'
import { meta } from '@/config/pagination'

const {
  GET_PRODUCT_ADDITIONAL,
  CREATE_UPDATE_PRODUCT,
  UPDATE_PRODUCT_SET_STOCK,
  GET_MAIN_PRODUCT_LIST,
  CREATE_MAIN_PRODUCT_LIST,
  UPDATE_MAIN_PRODUCT_LIST,
  PRODUCT_UPLOAD_EXCEL,
  MAIN_PRODUCT_UPLOAD_EXCEL,
  UPDATE_MAIN_PRODUCT_QTY,
  DELETE_PRODUCT,
  EXPORT_MAIN_PRODUCT,
} = path

export const defaultProduct = {
  campaignId: {},
  name: null,
  modelName: null,
  color: null,
  colorHex: '#000',
  imageUrl: null,
  size: null,
  sku: null,
  price: null,
  priceDeposit: null,
  conditionHtml: null,
  images: [''],
  bundleProduct: [],
  selectTab: 0,
  forceBundle: 0,
  productDropdown: [],
  metaProductDropdown: meta,
  // qtyBuffer: 0,
  // qtyRemain: 0,
  // qtyItec: 0,
  // qtyLock: 0,
}

export const defaultAddProductToCampaign = {
  campaignId: null,
  products: [],
}

const state = () => ({
  additionalProduct: [],
  productDataTypeAll: [],
  productDataTypeBundle: [],
  productDataTypeAdditional: [],
  cloneProductDataTypeAll: [],
  cloneProductDataTypeBundle: [],
  cloneProductDataTypeAdditional: [],
  cloneAdditionalProduct: [],
  isError: false,
  isLoading: false,
  selectAdditionalProducts: [],
  addProductToCampaign: defaultAddProductToCampaign,
  stockLoading: false,
  data: [],
  meta,
  loadingUploadFile: false,
  loadingDownloadFile: false,
  productDropdown: [],
  metaProductDropdown: meta,
})

// getters
const getters = {}

// actions
const actions = {
  async getProductDropdown({ commit }, params) {
    commit('SET_LOADING', true)
    try {
      params = JSON.parse(JSON.stringify(params))
      if (params.type === 'ทั้งหมด') delete params.type

      const res = await $axios(
        `${GET_MAIN_PRODUCT_LIST}`,
        'get',
        snakeCaseKeys({
          params,
        }),
      )

      commit('SET_STATE', {
        key: 'productDropdown',
        value: res?.data?.data,
      })

      commit('SET_STATE', {
        key: 'metaProductDropdown',
        value: res?.data?.meta,
      })

      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_STATE', {
        key: 'productDropdown',
        value: [],
      })
      commit('SET_STATE', meta)
      commit('SET_LOADING', false)

      throw error
    }
  },

  async getAdditionalProduct({ commit }) {
    try {
      const res = await $axios(GET_PRODUCT_ADDITIONAL, 'get')
      commit('SET_STATE', {
        key: 'additionalProduct',
        value: res?.data,
      })
      commit('SET_STATE', {
        key: 'cloneAdditionalProduct',
        value: res?.data,
      })
    } catch (e) {
      return new Error(e)
    }
  },

  async getProduct({ commit }, { type }) {
    try {
      if (
        type?.toUpperCase() === 'ALL' ||
        type?.toUpperCase() === 'BUNDLE' ||
        type?.toUpperCase() === 'ADDITIONAL'
      ) {
        const res = await $axios(
          path[`GET_PRODUCT_${type.toUpperCase()}`],
          'get',
        )

        commit('SET_STATE', {
          key: `productDataType${pascalCase(type)}`,
          value:
            type.toUpperCase() === 'ALL'
              ? [
                  ...(res?.data?.bundle || []),
                  ...(res?.data?.additional || []),
                ]
              : res?.data[type.toLowerCase()],
        })
      }
    } catch (e) {
      return new Error(e)
    }
  },

  async createAndUpdateProduct({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      await $axios(
        CREATE_UPDATE_PRODUCT,
        'post',
        snakeCaseKeys(payload),
      )
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },

  setProductDataTypeAll({ commit }, data) {
    commit('SET_STATE', {
      key: 'productDataTypeAll',
      value: data,
    })
  },

  setProductDataTypeBundle({ commit }, data) {
    commit('SET_STATE', {
      key: 'productDataTypeBundle',
      value: data,
    })
  },

  setProductDataTypeAdditional({ commit }, data) {
    commit('SET_STATE', {
      key: 'productDataTypeAdditional',
      value: data,
    })
  },
  setDataSort({ commit, state }, data) {
    commit('SET_STATE', {
      key: 'addProductToCampaign',
      value: {
        campaignId: state.addProductToCampaign.campaignId,
        products: data,
      },
    })
  },
  async updateStock({ commit }, payload) {
    try {
      commit('SET_STATE', {
        key: 'stockLoading',
        value: true,
      })
      await $axios(
        UPDATE_PRODUCT_SET_STOCK,
        'post',
        snakeCaseKeys(payload),
      )
      commit('SET_STATE', {
        key: 'stockLoading',
        value: false,
      })
    } catch (e) {
      commit('SET_STATE', {
        key: 'stockLoading',
        value: false,
      })
      throw e
    }
  },

  setSelectTab({ commit }, payload) {
    commit('SET_STATE', { key: 'selectTab', value: payload })
  },

  async getMainProduct({ commit }, params) {
    commit('SET_LOADING', true)
    try {
      const res = await $axios(
        `${GET_MAIN_PRODUCT_LIST}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_DATA', res?.data?.data)
      commit('SET_STATE', { key: 'meta', value: res?.data?.meta })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_DATA', null)
      commit('SET_STATE', meta)
      commit('SET_LOADING', false)

      throw error
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async getMainProductById({}, id) {
    try {
      const res = await $axios(
        `${GET_MAIN_PRODUCT_LIST}/${id}`,
        'get',
      )
      return res?.data?.data
    } catch (error) {
      return defaultProduct
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async createMainProduct({}, data) {
    // eslint-disable-next-line no-useless-catch
    try {
      let mapper = deepCopy(data)
      delete mapper.products?.[0]?.campaign_id
      delete mapper.products?.[0]?.id
      delete mapper.products?.[0]?.select_tab
      await $axios(CREATE_MAIN_PRODUCT_LIST, 'post', mapper)
    } catch (error) {
      throw error
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async editMainProduct({}, data) {
    let mapper = deepCopy(data)
    delete mapper.product.campaign_id
    delete mapper.product.id
    delete mapper.product.select_tab
    delete mapper.product.qty_buffer

    delete mapper.product.qty_commit
    delete mapper.product.qty_itec
    delete mapper.product.qty_lock
    delete mapper.product.qty_remain
    // eslint-disable-next-line no-useless-catch
    try {
      await $axios(
        `${UPDATE_MAIN_PRODUCT_LIST}/${data.product.id}`,
        'put',
        mapper,
      )
    } catch (error) {
      throw error
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async updateMainProductQty({}, data) {
    delete data.disable
    // eslint-disable-next-line no-useless-catch
    try {
      await $axios(
        `${UPDATE_MAIN_PRODUCT_QTY}/${data.id}`,
        'put',
        snakeCaseKeys(data),
      )
    } catch (error) {
      throw error
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async deleteMainProduct({}, id) {
    // eslint-disable-next-line no-useless-catch
    try {
      await $axios(`${UPDATE_MAIN_PRODUCT_LIST}/${id}`, 'delete')
    } catch (error) {
      throw error
    }
  },
  async mainProductUploadExcel({ commit }, data) {
    try {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: true,
      })
      await $axios(MAIN_PRODUCT_UPLOAD_EXCEL, 'post', data)
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    } catch (error) {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    }
  },
  async uploadExcel({ commit }, data) {
    try {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: true,
      })
      await $axios(PRODUCT_UPLOAD_EXCEL, 'post', data)
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    } catch (error) {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    }
  },
  async deleteProduct(_, id) {
    await $axios(`${DELETE_PRODUCT}/${id}`, 'delete')
  },
  async download({ commit }, query) {
    try {
      commit('SET_STATE', { key: 'loadingDownloadFile', value: true })
      await $axios(`${EXPORT_MAIN_PRODUCT}`, 'get', {
        params: snakeCaseKeys(query),
      }).then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `รายการสินค้า`
        link.click()
        URL.revokeObjectURL(link.href)
      })
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
    } catch (e) {
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
      return new Error(e)
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_PRODUCT_SELECTED(state, { item, index, type = 'Additional' }) {
    state[`productDataType${type}`][index] = item
  },
  REMOVE_SELECT_PRODUCT(state, index) {
    state.selectAdditionalProducts.splice(index, 1)
  },
  PUSH_ADDITIONAL_PRODUCT(state) {
    state.selectAdditionalProducts.push({
      id: makeId(8),
      groupName: null,
      products: [],
    })
  },
  ADD_ITEM_TO_ADDITIONAL_PRODUCT(state, { index, item }) {
    state.selectAdditionalProducts[index].products.push(item)
  },
  REMOVE_ITEM_ON_ADDITIONAL_PRODUCT(state, { indexProduct, index }) {
    state.selectAdditionalProducts[index].products.splice(
      indexProduct,
      1,
    )
  },
  CLEAR_SELECTED_AD_PRODUCT(state) {
    state.cloneAdditionalProduct.forEach((product) => {
      product.select = false
    })
  },
  ADD_CAMPAIGN_PRODUCT_IMAGE(state, index) {
    state.addProductToCampaign.products[index].images.push('')
  },
  REMOVE_CAMPAIGN_PRODUCT_IMAGE(state, { pIndex, index }) {
    state.addProductToCampaign.products[pIndex].images.splice(
      index,
      1,
    )
  },
  ADD_CAMPAIGN_PRODUCT(state) {
    state.addProductToCampaign.products.push(defaultProduct)
  },
  REMOVE_PRODUCT_BY_INDEX(state, index) {
    state.addProductToCampaign.products.splice(index, 1)
  },
  CREATE_OR_DUPLICATE_CAMPAIGN_PRODUCT(state, data) {
    state.addProductToCampaign.products.push(data)
  },
  SET_CAMPAIGN_PRODUCT_BY_ID(state, { data, index }) {
    state.addProductToCampaign.products[index] = data
  },
  SET_DATA(state, payload) {
    state.data = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
